import React from 'react';
import { useTranslation } from 'react-i18next';

const NewsListingTile = (props: any) => {
	const { blogroll } = props;
	const { t } = useTranslation();

	// get date string
	const [date, month, year] = new Date(blogroll.post_date.substr(0,10).replace(/-/g, "/"))
	.toLocaleDateString('en-GB', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
	})
	.split(' ');
	return (
		<div
			className={`blogroll-results__item blogroll-results__item--${blogroll.post_type}`}
		>
			<div className="blogroll-results__item-content">
				<span className="blogroll-results__item-date">
					<>
						{'page' !== blogroll.post_type ? (
							`${month} ${date}, ${year}`
						) : (
							t('Page')
						)}
					</>
				</span>
				<a href={blogroll.permalink} className="blogroll-results__item-link">
					<h5 className="blogroll-results__item-heading">
						{blogroll.post_title}
						<span className="blogroll-results__item-icon icon icon-arrow-right"></span>
					</h5>
				</a>
			</div>
		</div>
	);
};

export default NewsListingTile;
